import { makeRequest } from 'utils/requestLogger';

export default (id, roundtable_id, payload) =>
    makeRequest('post', `/api/recaps/${id}/roundtable/${roundtable_id}/follow-up-questions`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/recap/genieRecapGenerateFollowUpQuestions.js